import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLoginErrorPageStyles = makeStyles({
  centeredPage: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    paddingTop: tokens.spacingVerticalXXXL,
    paddingBottom: tokens.spacingVerticalXXXL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    backgroundColor: tokens.colorNeutralBackground2,
    backgroundImage: 'linear-gradient(135deg, rgba(232, 242, 247, 0.72), rgba(250, 244, 244, 0.62) 52%, rgba(232, 242, 247, 0.72))',
  },
  card: {
    width: '480px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow16,
  },
  logo: {
    width: '157px',
    height: '24px',
    display: 'block',
    objectFit: 'contain',
  },
  illustration: {
    marginTop: tokens.spacingVerticalS,
    '& svg': {
      width: '96px',
      height: '96px',
      display: 'block',
    },
  },
  title: {
    marginTop: tokens.spacingVerticalS,
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
    color: tokens.colorNeutralForeground2,
  },
  choiceField: {
    marginTop: tokens.spacingVerticalM,
    rowGap: tokens.spacingVerticalXS,
    color: tokens.colorNeutralForeground1,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
    marginTop: tokens.spacingVerticalM,
  },
});
